import React from "react";

const formatarMoeda = (valor) => {
  const numero = typeof valor === "string"
    ? Number(valor.replace(/\./g, "").replace(",", "."))
    : typeof valor === "number"
      ? valor
      : 0;

  if (isNaN(numero)) return "R$ 0,00";

  return numero.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const MeusResultados = ({
  valorVendido,
  leadsPerdidos,
  dataDe,
  dataAte,
  faturamentoTotal,
  dataAtualizacao,
}) => {
  return (
    <div className="container my-4">
      <div className="row">
        <div className="col-md-12">
          <h3 className="card-title text-dark font-weight-bold mb-4">Meus Resultados</h3>

          <div className="form-group">
            <label>Valor vendido até agora (R$):</label>
            <input
              type="text"
              className="form-control"
              value={formatarMoeda(valorVendido)}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>Leads perdidos:</label>
            <input
              type="text"
              className="form-control"
              value={`${leadsPerdidos} leads`}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>Faturamento total (R$):</label>
            <div className="form-row">
              <div className="col-md-3 mb-2">
                <label className="small">De:</label>
                <input
                  type="text"
                  className="form-control"
                  value={dataDe}
                  readOnly
                />
              </div>
              <div className="col-md-3 mb-2">
                <label className="small">Até:</label>
                <input
                  type="text"
                  className="form-control"
                  value={dataAte}
                  readOnly
                />
              </div>
            </div>
            <input
              type="text"
              className="form-control"
              value={formatarMoeda(faturamentoTotal)}
              readOnly
            />
          </div>

          <div className="d-flex align-items-center mt-3 text-muted">
            <i className="fas fa-clock mr-2 text-warning"></i>
            <small>Atualizado em: {dataAtualizacao}</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeusResultados;
